module.exports = "/images/vessel-16.jpg";